import { PageId } from 'constants/pages'

export const enum PageIdWoofzOffer170 {
  SUBSCRIPTIONS_OFFER1_70 = PageId.SUBSCRIPTIONS_OFFER1_70,
  CHAT_UPSELL_OFFER1_70 = PageId.CHAT_UPSELL_OFFER1_70,
  UPSELL_OFFER1_70 = PageId.UPSELL_OFFER1_70,
  DOWNLOAD_OFFER1_70 = PageId.DOWNLOAD_OFFER1_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
